
import React, { useEffect, useState } from 'react';
import {
    ChevronRight,
    Work,
    Group,
    School,
    Menu,
    Close,
} from '@mui/icons-material';
// React-Bootstrap Components
import {
    Container, Row, Col, Navbar, Nav,
    Button, Accordion
} from 'react-bootstrap';
import JobCard from './JobCard';

export default function CareersViewPage({ jobAdvertisements, filterHandler,
    applyHandler, onOpenFilter }) {
    const [data, setData] = useState()
    const [expanded, setExpanded] = useState(false);
    const showHeroImage = true;
    const faqs = [
        {
            id: 1,
            question: "What types of positions are available at CHRIST (Deemed to be University)?",
            answer: "CHRIST (Deemed to be University) offers a wide range of positions including Faculty positions (across various departments and disciplines), Non-Teaching Staff positions (administrative, technical, and support roles), Research positions, and Post-Doctoral Fellowships. Positions are available across our campuses in Bangalore, Lavasa Pune, and NCR Delhi."
        },
        {
            id: 2,
            question: "How do I apply for a position?",
            answer: "You can apply for positions in two ways: 1) Apply to the General Pool by clicking the 'Apply to General Pool' button, which allows you to submit your profile for future opportunities. 2) Search for specific open positions using the 'Search Open Positions' button and apply directly to positions that match your qualifications and interests."
        },
        {
            id: 3,
            question: "What are the eligibility criteria for Faculty positions?",
            answer: "Eligibility criteria vary by position and department. Generally, Faculty positions require relevant academic qualifications (Ph.D. or equivalent), teaching experience, research publications, and subject expertise. Specific requirements are detailed in each job advertisement. Please refer to the individual job postings for detailed eligibility criteria."
        },
        {
            id: 4,
            question: "Can I apply for multiple positions?",
            answer: "Yes, you can apply for multiple positions that match your qualifications and interests. Each application is considered independently. We recommend tailoring your application to highlight relevant experience and qualifications for each specific position."
        },
        {
            id: 5,
            question: "What is the application process timeline?",
            answer: "The application process timeline varies depending on the position and department. Typically, the process includes application submission, initial screening, shortlisting, interviews, and final selection. You will be notified via email at each stage of the process. Please check individual job advertisements for specific deadlines and timelines."
        },
        // {
        //     id: 6,
        //     question: "What benefits and perks does the University offer?",
        //     answer: "CHRIST (Deemed to be University) offers comprehensive benefits including competitive salaries, health insurance, retirement plans, professional development opportunities, research grants, housing assistance (where applicable), and access to world-class facilities and resources. Specific benefits may vary by position and campus location."
        // },
        {
            id: 7,
            question: "Are there opportunities for professional development?",
            answer: "Yes, the University strongly encourages and supports professional development. We offer various programs including faculty development workshops, research funding opportunities, conference attendance support, continuing education programs, and career advancement pathways. The University is committed to supporting the growth and development of all employees."
        },
        {
            id: 8,
            question: "How can I track the status of my application?",
            answer: "After submitting your application, you will receive a confirmation email. You can track your application status through the application portal. You will also receive email notifications at key stages of the recruitment process, including if you are shortlisted for interviews or if additional information is required."
        }
    ];

    // --- CSS Overrides for Exact UI Match & Responsiveness ---
    const styles = `
    :root {
      --brand-navy: #1e3a8a;
      --brand-orange: #f97316;
      --brand-orange-hover: #ea580c;
    }

    /* Colors */
    .bg-navy { background-color: var(--brand-navy) !important; }
    .text-navy { color: var(--brand-navy) !important; }
    .text-orange { color: var(--brand-orange) !important; }
    
    /* Buttons */
    .btn-orange {
      background-color: var(--brand-orange);
      border: none;
      color: white;
      font-weight: 600;
      transition: all 0.2s ease;
    }
    .btn-orange:hover {
      background-color: var(--brand-orange-hover);
      color: white;
      transform: translateY(-2px);
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    }

    /* Gradients & Backgrounds */
    .hero-bg {
      background: #0b3f64be;
      position: relative;
    }
    .hero-overlay {
      background: rgba(0,0,0,0.2);
    }
    
    /* Category Cards Gradients */
    .grad-card-blue { background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%); }
    .grad-card-orange { background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%); }
    .grad-card-green { background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%); }
    
    /* Hover Effects */
    .hover-card {
      transition: all 0.3s ease;
      cursor: pointer;
      border: none;
    }
    .hover-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    }
    
    /* Carousel Styling */
    .job-carousel { height: 250px; background-color: #f8f9fa; }
    .job-carousel .carousel-item { height: 100%; }
    .job-carousel img { width: 100%; height: 100%; object-fit: cover; }
    
    /* Navbar Customization */
    .navbar-custom .nav-link {
      color: rgba(255,255,255,0.85) !important;
      font-weight: 500;
      transition: 0.2s;
    }
    .navbar-custom .nav-link:hover { color: white !important; }
    
    /* Accordion Custom */
    .accordion-button:not(.collapsed) {
      color: var(--brand-navy);
      background-color: #f1f5f9;
      box-shadow: none;
    }
    .accordion-button:focus { box-shadow: none; border-color: rgba(0,0,0,0.1); }

    /* RESPONSIVE TWEAKS */
    @media (max-width: 991px) {
        .hero-title { font-size: 2.2rem !important; }
        .hero-subtitle { font-size: 1.5rem !important; }
        .hero-padding { padding: 30px 15px !important; }
        .hero-content-padding { padding-left: 0px !important; text-align: center; }
        .hero-video-col { padding: 20px 0px !important; margin-top: 20px; }
        .hero-btn-container { justify-content: center !important; }
        .stat-border-right { border-right: none !important; border-bottom: 1px solid rgba(255,255,255,0.2); padding-bottom: 1.5rem; margin-bottom: 1.5rem; }
    }
    @media (min-width: 992px) {
        .hero-title { font-size: 3rem !important; }
        .hero-padding { padding: 50px !important; }
        .hero-content-padding { padding-left: 30px !important; }
        .hero-video-col { padding: 50px 20px !important; }
        .stat-border-right { border-right: 1px solid rgba(255,255,255,0.2) !important; }
    }
  `;





    const navigateHandler = (value) => {
        filterHandler(value)
        onOpenFilter();
    }

    const openPositionHandler = () => {
        filterHandler();
        onOpenFilter();
    }



    useEffect(() => {
        setData(jobAdvertisements)
        // console.log(data, "Data")
    }, [jobAdvertisements])
    return (
        <div className="overflow-auto">
            <style>{styles}</style>
            {/* --- HEADER --- */}
            <div className=''>
                {/* <Navbar
                    expanded={expanded}
                    expand="lg"
                    className="bg-navy navbar-custom py-3 sticky-top shadow"
                    variant="dark"
                >
                    <Container fluid="xl" className='container-'>
                        <Navbar.Brand onClick={() => navigate('/')} className="d-flex align-items-center gap-2 gap-md-3 cursor-pointer">
                            <i class="fa-solid fa-graduation-cap" style={{ fontSize: 32 }}></i>
                            <h4 className="m-0 fs-md-4 fw-bold fs-4" style={{ lineHeight: "3rem" }}>
                                CHRIST <span className="d-none d-sm-inline">(Deemed to be University)</span><span className="d-sm-none">University</span> Careers
                            </h4>
                        </Navbar.Brand>

                        <Navbar.Toggle onClick={() => setExpanded(!expanded)} aria-controls="navbar-nav" className="border-0">
                            {expanded ? <Close style={{ fontSize: 28 }} /> : <Menu style={{ fontSize: 28 }} />}
                        </Navbar.Toggle>

                        <Navbar.Collapse id="navbar">
                            <Nav className="ms-auto align-items-center gap-lg-3 mt-3 mt-lg-0">
                                {['Jobs', 'Benefits', 'Culture'].map((item) => (
                                    <Nav.Link
                                        key={item}
                                        href={`#${item.toLowerCase()}`}
                                        className='navbar-link w-100 text-center text-lg-start py-2'
                                        onClick={() => setExpanded(false)}
                                    >
                                        {item}
                                    </Nav.Link>
                                ))}
                                <Nav.Link onClick={() => navigate('/ApplicationForm')}>Apply</Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar> */}

                {/* --- HERO SECTION --- */}
                <section className="hero-bg text-white overflow-hidden hero-padding">
                    <div className="hero-overlay position-absolute top-0 start-0 w-100 h-100"></div>

                    <div fluid="xl" className="position-relative py-3 py-lg-5 d-flex justify-content-center hero-content-padding">
                        <Row className="align-items-center">
                            <Col lg={showHeroImage ? 6 : 10} className="">
                                <h1 className="hero-title" style={{ fontWeight: "bolder" }}>
                                    Join CHRIST
                                </h1>
                                <h3 className="mb-3 hero-subtitle" style={{ color: "rgb(191 219 254 )" }}>(Deemed to be University)</h3>
                                <h1 className="mt-3 d-block text-white" style={{ fontWeight: "bolder", fontSize: "3rem" }}>Nurture Excellence, Transform Future, Build Your Career</h1>

                                <p className="text-lg md:text-xl mb-4 text-blue-100 leading-relaxed mt-4" style={{ color: "rgb(191 219 254 )" }}>
                                    Discover a workplace where your talent is nurtured, your ideas matter, and your journey of growth becomes part of a legacy of excellence.
                                </p>
                                <div className="d-flex flex-column flex-sm-row gap-3 hero-btn-container">
                                    <Button
                                        onClick={() => applyHandler()}
                                        variant='light'
                                        className=" px-4 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2 text-white"
                                        style={{ border: "none", background: "orange", fontWeight: "" }}

                                    >
                                        Apply to General Pool
                                        <ChevronRight />
                                    </Button>
                                    <Button
                                        onClick={() => openPositionHandler()}
                                        variant="light"
                                        className="px-4 py-3 rounded-3 text-navy fw-bold d-flex align-items-center justify-content-center gap-2"
                                    >
                                        Search Open Positions
                                        <ChevronRight />
                                    </Button>
                                </div>
                            </Col>


                            {showHeroImage && (
                                <Col lg={6} className='mt-2'>
                                    <div className="ratio ratio-16x9 rounded-4 overflow-hidden shadow-lg bg-dark">
                                        <video
                                            src={`${process.env.PUBLIC_URL}/promo-vedio.mp4`}
                                            autoPlay loop muted playsInline
                                            style={{ objectFit: 'cover' }}
                                        />
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </div>

                    {/* Bottom Fade */}
                    <div className="position-absolute bottom-0 start-0 w-100" style={{ height: '60px', background: 'linear-gradient(to top, white, transparent)' }}></div>
                </section>

                {/* --- INTRO TEXT --- */}
                <section className="py-5 card  m-2 " style={{ background: "#17a2b833" }}>
                    <Container className=''>
                        <Accordion className='border-none bg-info'>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <p className="fs-5 text-dark fw-light" style={{ lineHeight: '' }}>
                                        {/* <b> */}
                                        At CHRIST (Deemed to be University), every role matters. Whether you are a faculty
                                        member, academic leader, administrative professional, support staff, or office assistant, you
                                        are part of a values-driven institution committed to excellence, ethics, and service to society
                                        {/* </b> */}
                                        .</p>

                                </Accordion.Header>

                                <Accordion.Body>
                                    <p>
                                        We offer more than a job — we offer a purposeful professional journey grounded in dignity,
                                        collaboration, accountability, and continuous growth.
                                    </p>

                                    <div className='text-center'>
                                        <h6 className="fw-bold mt-3">Purpose-Driven Work</h6>
                                        <p>
                                            Your work contributes directly to education, research, service, and
                                            societal impact.
                                        </p>

                                        <h6 className="fw-bold mt-3">Inclusive and Respectful Culture</h6>
                                        <p>
                                            A collegial workplace where diversity of roles and perspectives is
                                            valued, and every contribution is recognised.
                                        </p>

                                        <h6 className="fw-bold mt-3">Learning and Career Growth</h6>
                                        <p>
                                            Structured training, mentoring, leadership development, and
                                            opportunities to grow across roles and responsibilities.
                                        </p>

                                        <h6 className="fw-bold mt-3">Values-Centric Institution</h6>
                                        <p>
                                            Integrity, ethics, transparency, and accountability guide our
                                            decisions and practices.
                                        </p>

                                        <h6 className="fw-bold mt-3">Collaborative Academic Ecosystem</h6>
                                        <p>
                                            Faculty, administrators, and staff work together in a shared mission
                                            of excellence.
                                        </p>

                                        <h6 className="fw-bold mt-3">Supportive Work Environment</h6>
                                        <p>
                                            Employee well-being, safe campuses, and systems that support balance
                                            and long-term engagement.
                                        </p>

                                        <h6 className="fw-bold mt-3">
                                            Technology-Enabled and Sustainable Campuses
                                        </h6>
                                        <p>
                                            Modern digital systems and environmentally responsible infrastructure
                                            that enable efficiency and innovation.
                                        </p>

                                        <h6 className="fw-bold mt-3">Our Promise</h6>
                                        <p>
                                            At CHRIST University, you will find meaningful work, ethical
                                            leadership, opportunities to grow, and a community committed to
                                            excellence and service.
                                        </p>

                                        <p className="fw-bold mb-0">
                                            Not just a workplace — a shared mission.
                                            <br />
                                            Not just a career — a commitment with purpose.
                                        </p>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        {/* <Row className="justify-content-center">
                            <Col lg={9} className="text-center">
                                <p className="fs-5 text-dark fw-light" style={{ lineHeight: '1.8' }}>
                                    Are you a passionate educator, an innovative researcher, or a dedicated professional ready to contribute to a vibrant academic community? CHRIST (Deemed to be University) invites dynamic and qualified individuals to apply for positions across our campuses in <span className="fw-bold text-navy">Bangalore, Lavasa Pune, and NCR Delhi.</span>
                                </p>
                            </Col>
                        </Row> */}

                    </Container>
                </section>

                {/* --- JOB LISTINGS SECTION --- */}
                <section id="jobs" className="py-3 bg-light container p-3">
                    <div fluid="xl" className='container'>
                        <div className="text-center mb-5 px-3">
                            <h2 className="display-6 fw-bold mb-3">Job Advertisement Posters/Documents</h2>
                            <p className="text-muted">Explore our latest job advertisements.</p>
                        </div>

                        <Row className="g-0 justify-content-center">
                            {data?.length === 0 ? (
                                <Col className="text-center py-5 text-muted">No active positions found.</Col>
                            ) : (
                                <>
                                    {data?.map((ad) => (
                                        <JobCard key={ad.id}
                                            ad={ad}
                                            jobAdvertisements={data}
                                            width="6"
                                            applyHandler={applyHandler}
                                        />
                                    ))}
                                </>
                            )}
                        </Row>
                    </div>
                </section>

                {/* --- CATEGORIES SECTION --- */}
                <section className="py-5">
                    <Container fluid="xl">
                        <Row className="g-4">
                            <Col md={4}>
                                <div
                                    onClick={() => navigateHandler("1")}
                                    className="grad-card-blue p-4 p-lg-5 rounded-4 h-100 hover-card"
                                >
                                    <div className="bg-primary text-white rounded-circle d-inline-flex p-3 mb-4 shadow-sm">
                                        <School style={{ fontSize: 32 }} />
                                    </div>
                                    <h3 className="h4 fw-bold text-navy mb-3">Faculty Positions</h3>
                                    <p className="text-secondary mb-4">Join a community of distinguished scholars where your expertise will drive innovation.</p>
                                    <div className="text-primary fw-bold d-flex align-items-center gap-1">
                                        View Openings
                                        <ChevronRight style={{ fontSize: 16 }} />
                                    </div>
                                </div>
                            </Col>

                            <Col md={4}>
                                <div
                                    onClick={() => navigateHandler("2")}
                                    className="grad-card-orange p-4 p-lg-5 rounded-4 h-100 hover-card"
                                >
                                    <div className="bg-orange text-white rounded-circle d-inline-flex p-3 mb-4 shadow-sm" style={{ backgroundColor: '#f97316' }}>
                                        <Work style={{ fontSize: 32, color: "white" }} />
                                    </div>
                                    <h3 className="h4 fw-bold text-dark mb-3" style={{ color: '#7c2d12' }}>Staff Positions</h3>
                                    <p className="text-secondary mb-4">Join our community of career professionals in IT, healthcare, administration, and more.</p>
                                    <div className="fw-bold d-flex align-items-center gap-1" style={{ color: '#ea580c' }}>
                                        View Openings
                                        <ChevronRight style={{ fontSize: 16 }} />
                                    </div>
                                </div>
                            </Col>

                            <Col md={4}>
                                <div
                                    onClick={() => navigateHandler("3")}
                                    className="grad-card-green p-4 p-lg-5 rounded-4 h-100 hover-card"
                                >
                                    <div className="bg-success text-white rounded-circle d-inline-flex p-3 mb-4 shadow-sm">
                                        <Group style={{ fontSize: 32 }} />
                                    </div>
                                    <h3 className="h4 fw-bold text-dark mb-3" style={{ color: '#14532d' }}>Research & Others</h3>
                                    <p className="text-secondary mb-4">Launch your career with student employment, internships, and work-study programs.</p>
                                    <div className="text-success fw-bold d-flex align-items-center gap-1">
                                        View Openings
                                        <ChevronRight style={{ fontSize: 16 }} />
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* --- CULTURE SECTION --- */}
                <section id="culture" className="py-5 bg-navy text-white">
                    <Container fluid="xl" className="py-lg-5">
                        <div className="text-center mb-5">
                            <h2 className="display-5 fw-bold mb-4">A Culture of Care & Excellence</h2>
                            <Row className="justify-content-center">
                                <Col lg={8}>
                                    <p className="lead text-white-50">
                                        Build your career with a university that embraces innovation, champions learning, and believes in the power of people.
                                    </p>
                                </Col>
                            </Row>
                        </div>

                        <Row className="text-center gy-4">
                            <Col md={4} className="stat-border-right">
                                <div className="display-4 fw-bold text-orange mb-2">3000+</div>
                                <div className="h5 text-white-50">Employees</div>
                            </Col>
                            <Col md={4} className="stat-border-right">
                                <div className="display-4 fw-bold text-orange mb-2">120+</div>
                                <div className="h5 text-white-50">Departments</div>
                            </Col>
                            <Col md={4}>
                                <div className="display-4 fw-bold text-orange mb-2">57+</div>
                                <div className="h5 text-white-50">Years of Excellence</div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* --- FAQ SECTION --- */}
                <section className="py-5 bg-light">
                    <Container style={{ maxWidth: '800px' }} className=''>
                        <h2 className="display-6 fw-bold text-dark text-center mb-5">Frequently Asked Questions</h2>
                        <Accordion>
                            {faqs.map((faq, index) => (
                                <Accordion.Item eventKey={String(index)} key={faq.id} className="mb-3 border rounded overflow-hidden shadow-sm">
                                    <Accordion.Header>{faq.question}</Accordion.Header>
                                    <Accordion.Body className="bg-light text-secondary">
                                        {faq.answer}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </Container>
                </section>

                {/* --- FOOTER --- */}
                <footer className=" py-4 " style={{ height: "" }}>
                    <div className=" pt-4 text-center">
                        <div className="container">©  CHRIST (Deemed to be University). All rights reserved. | Equal Opportunity Employer</div>
                    </div>
                </footer>


            </div>
            {/* <CategoryFilter jobAdvertisements={jobAdvertisements} setFilter={setFilter} dashboardHandler={dashboardHandler} /> */}
            {/* <div>
                <Modal
                    show={isShowImage}
                    onHide={() => setIsShowImage(false)}
                    size="lg"
                    scrollable
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {isTextType ? "Job Advertisement" : "View Full Image"}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {!isTextType ? (
                            <img
                                src={fullImage}
                                alt="titei"
                                // onClick={() => showImageHandler(ad.url)}
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    border: "1px solid black",
                                    objectFit: "cover",
                                    cursor: "pointer"
                                }}
                            />
                        ) : (
                            <div>
                                {content}
                            </div>
                        )}
                    </Modal.Body>
                </Modal>
            </div> */}
        </div>
    );
}